import { ReportAction, ReportFileType, ReportParamSetType, ReportParamType, ReportSpecType } from "app/utility/enums";
import { LookupExternalModel, LookupInternalModel } from "../shared/lookup.model";
import { ContactResultModel } from "./contact.model";
import { EmailModel } from "../shared/email.model";

export class ReportSpecModel
{
    reportSpecId: string;
    shortDesc: string;
    name: string;
    description: string;
    comment: string;
    subject: string;
    reportType: string;
    specType: ReportSpecType;
    reportParamType: ReportParamTypeModel[];
    reportParamSets: ReportParamSetModel[];

	//transient
	selected: boolean = false;
}

export class ReportParamTypeModel
{
    name: string;
    type: ReportParamType;
}

export class ReportParamSetModel
{
    reportSpecId: string;
    reportParamSetId: string;
    paramSetType: ReportParamSetType;
    sequence: number;
    type: ReportParamType;
    reportParamName: string;
    paramLabelOverride: string;
    reference: string;
    reportParamValue: any;
    reportParamObject: any;

    noneLabel: string;
    
    // Transient
    paramId: string;
    paramLabel: string;
}

export class ReportParamsPayloadModel
{
    reportSpecId: string;
    reportName: string;
    reportParamsString: string;
    reportFileType: ReportFileType;
    reportParams: ReportParamSetModel[];
}

export class ReportActionRequestModel
{
    reportSpecId: string;
    reportAction: ReportAction;
    taskId: string;
    currentPage: number;
    email: EmailModel;
}